import { Pipe, PipeTransform } from '@angular/core';

import { blockTimeRecordStatusLabels } from '../block-time-report.config';

@Pipe({
  name: 'blockTimeRecordStatusLabel',
  standalone: true,
})
export class BlockTimeRecordStatusLabelPipe implements PipeTransform {
  /**
   * Maps a block_time_records.Status value to its display label, falling back to the raw value.
   */
  transform(status: string | null | undefined): string {
    if (!status) {
      return '';
    }

    return blockTimeRecordStatusLabels[status] ?? status;
  }
}
